export default {

  'menu.live': 'gestión de sala en vivo',
  'menu.room': 'lista de salas en vivo',
  'menu.audit': 'auditoría de sala en vivo',
  'menu.gift': 'gestión de regalos',
  'menu.giftItem': 'lista de regalos',
  'menu.instruction': 'lista de avisos de sala en vivo',
  'menu.livePlatform': 'gestión de plataforma en vivo',
  'menu.region': 'gestión de región en vivo',
  'menu.filterWord': 'gestión de palabras filtradas',
  'menu.hotWeight': 'gestión de peso de popularidad',

};
